import { Box, Typography, Grid, Container } from "@mui/material";
import React from "react";
import RelatedProductCard from "../cards/RelatedProductCard";
import RelatedProductData from "../../json/RelatedProduct.json";
import ProductCard from "../cards/ProductCard";
import { t } from "i18next";

const RelatedProducts = ({ products }) => {
  return (
    <Box>
      <Typography
        variant="heading_pr"
        component={"h1"}
        textAlign={"center"}
        textTransform={"capitalize"}
      >
        {t("relatedProducts")}
      </Typography>

      <Container maxWidth={"lg"}>
        <Grid container spacing={2} my={2}>
          {products?.map((val, index) => {
            return (
              <Grid key={index} item xs={12} sm={4} md={3}>
                <RelatedProductCard data={val} />
              </Grid>
            );
          })}
        </Grid>

        {/* <Grid container spacing={2} mt={2}>
          {products?.map((item, index) => (
            <Grid key={index} item xs={12} sm={4} md={3}>
              <ProductCard cardData={item} colorName={"text.black"} />
            </Grid>
          ))}
        </Grid> */}
      </Container>
    </Box>
  );
};

export default RelatedProducts;
